// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  xapikey: 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJWQkkifQ.lilpncVK7gJsrolv9cmhOZ-tKu84M_1wBO6C0mvd6zkzhvwH5r9wv078_qJEOrAm3YDWVdrm7Ixn_8l_u6Y-eA',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
